import React from 'react';
import {Link} from "react-router-dom";
import {ChevronRightIcon} from "@heroicons/react/solid";
import {concatenate} from "services/string";

type Props = {
    name: string
    path: string
    isFirst: boolean
}

function Breadcrumb(props: Props) {
    const {name, path, isFirst} = props

    return (
        <li>
            <div className="flex">
                {!isFirst? <ChevronRightIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" /> : null}
                <Link to={path} className={concatenate(!isFirst? 'ml-4' : null, 'text-sm font-medium text-gray-500 hover:text-gray-700 sm:truncate line')}>
                    {name}
                </Link>
            </div>
        </li>
    );
}

Breadcrumb.defaultProps = {
    isFirst: false
}

export default Breadcrumb;